import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs/internal/Subscription';
import { MapValuePipe } from '../../pipes/map-value.pipe';
import { ScreenResizeService } from '../../services/screen-resize.service';
import { IViewConfig } from '../tqw-view/models/view-config.model';
import { ActionsStyle } from './enums/actions-style.enum';
import { Column } from './enums/column.enum';
import { IColumn } from './models/column.model';
import { ITableConfig } from './models/table-config.model';

@Component({
    selector: 'app-custom-table',
    templateUrl: './custom-table.component.html',
    styleUrls: ['./custom-table.component.scss'],
    providers: [MapValuePipe]
})
export class CustomTableComponent<T = unknown> implements OnInit, OnChanges, AfterViewInit {
    @ViewChild(MatSort) sort!: MatSort;

    @Input() public config!: ITableConfig<T>;
    @Input() public contents!: TemplateRef<any>[];

    @Output() public paginatorChange: EventEmitter<number> = new EventEmitter();
    @Output() public takeAction: EventEmitter<any> = new EventEmitter();
    @Output() public sortChange: EventEmitter<Sort> = new EventEmitter();
    @Output() public selectFilter: EventEmitter<Sort> = new EventEmitter();
    private _mapValuePipe: MapValuePipe = inject(MapValuePipe);
    resizeSubscription$: Subscription;
    screenSize!: string;
    isMobileScreen: boolean;
    public defaultConfig: ITableConfig<T> = {
        dataSource: new MatTableDataSource(),
        displayedColumns: [],
        pageSizeOptions: [10, 20, 30, 40, 50, 100, 200],
        pageSize: 20,
        pageIndex: 0,
        spinnerColor: '#4f008c'
    };

    protected readonly ColumnTypes = Column;
    protected readonly ActionsStyle = ActionsStyle;
    public mobileViewConfig!: IViewConfig<IColumn>;
    public mobileData!: any;
    constructor(private screenResizeService: ScreenResizeService) {}
    ngOnInit(): void {
        this.setDefaultTableConfig();
        this.resizeSubscription$ = this.screenResizeService.onResize$.subscribe((screenSize: string) => {
            this.screenSize = screenSize;
            this.isMobileScreen = screenSize === 'xs';
        });
        console.log('config', this.config);
    }

    ngAfterViewInit(): void {
        this.setDataSourceSort();
    }
    setDefaultTableConfig(): void {
        this.defaultConfig = {
            ...this.defaultConfig,
            ...this.config
        };
    }

    setDataSourceSort(): void {
        this.config.dataSource.sort = this.sort;
    }

    onPaginatorChange(pageIndex: number): void {
        this.paginatorChange.emit(pageIndex);
    }
    protected getColumnsName(): string[] {
        return this.config.displayedColumns?.map(column => column.label) || [];
    }

    onTakeAction(e: any) {
        this.takeAction.emit(e);
    }

    onSortChange(sortState: Sort) {
        this.sortChange.emit(sortState);
    }
    OnSelectFilter(event: any) {
        this.selectFilter.emit(event);
    }
    setMobileData() {
        //get mobile columns to display it in list view in mobile
        const MOBILE_COLUMNS = this.config.displayedColumns?.filter(column => column.type != this.ColumnTypes.Actions);
        //set mobile view config
        this.mobileViewConfig = {
            colsCount: 12,
            list: MOBILE_COLUMNS?.map(column => {
                return {
                    label: column.label,
                    value: column
                };
            })
        };
        this.mobileData=this.config.dataSource.data;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['config'].currentValue) {
            this.setMobileData();
        }
    }
    OnDestroy() {
        this.resizeSubscription$.unsubscribe();
    }
}
